import { useFormController } from "../../form/useFormController";
import { useStaticDataAtomValue } from "../../staticDataAtom";
import { DiscountLayout } from "./DiscountLayout";

export const First3BookingController = () => {
    const {
        cmsData: {
            pricing: { first3BookingDiscount },
        },
    } = useStaticDataAtomValue();
    const { value, setValue } = useFormController("first3BookingDiscount", {
        defaultValue: true,
    });

    return (
        <DiscountLayout
            id="first3booking"
            title={first3BookingDiscount}
            selected={value}
            onClick={setValue}
            toggleDataElementName="first3-booking-promotion"
        />
    );
};
